import * as React from 'react';
import { TableCellProps } from './TableProps';

type Props = TableCellProps<any, number>;

export const CurrencyCell: React.FC<Props> = ({ value, formattedValue }) => {
  return <span>{value !== undefined && value !== null && formattedValue}</span>;
};
